import { useNavigate } from 'react-router-dom';
import { useEffect, ReactNode } from 'react';
import { useActivityData } from '../chatroom/manage/UseActivityData';
import { UserRole } from '../models/userRole';

export default function ActivityDashboardGuard({
  children,
  isChildActivityDashboard = false,
}: {
  children: ReactNode;
  isChildActivityDashboard: boolean;
}) {
  const navigate = useNavigate();
  const { room } = useActivityData();

  useEffect(() => {
    if (isChildActivityDashboard) {
      if (room?.role === UserRole.CUSTOMER || room?.role === UserRole.MEMBER) {
        navigate('/');
      }
    } else {
      if (
        room?.role === UserRole.PARTNER ||
        room?.role === UserRole.CUSTOMER ||
        room?.role === UserRole.MEMBER
      ) {
        navigate('/');
      }
    }
  }, [navigate, room, isChildActivityDashboard]);

  return <>{children}</>;
}
